import { DraggablePanel } from '@components/ui/draggable';
import { FormattedMessage } from 'react-intl';

import { PopupComponentProps, PopupTypeEnum } from '@/types/popup.types';

import RoundContent from './RoundContent';

export function RoundPopup({
  mapConstraintsRef,
  data,
  top,
  left,
  onClose,
}: Readonly<PopupComponentProps<PopupTypeEnum.ROUND>>) {
  return (
    <DraggablePanel.Root constraintsRef={mapConstraintsRef} top={top} left={left} key={data.featureValue}>
      <DraggablePanel.Header onClose={onClose}>
        <FormattedMessage id="rounds.roundPopup" />
      </DraggablePanel.Header>
      <DraggablePanel.Body width={496} height={472}>
        <RoundContent uniqueKey={data.featureValue} />
      </DraggablePanel.Body>
    </DraggablePanel.Root>
  );
}
